/**
 * Created by Vishnu on 2023-07-06
 */
import {WinPresentationController} from "../WinPresentationController";
import {DDay} from "../../DDay";
import {Layers} from "../../view/DDayLayers";
import {Power2, TimelineLite, TweenLite} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {DDayGameConfig} from "../../DDayGameConfig";
import {BlitzkriegSymbols, BlitzKriegSymbolState} from "../../symbol/DDaySymbolConfig";
import {BlitzKriegReelController} from "../../reels/BlitzKriegReelController";
import {IFeatureData} from "../../server/data/IBlitzKriegData";
import {DDaySymbol} from "../../symbol/DDaySymbol";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BlitzKriegGameMode} from "../../server/BlitzKriegGameMode";
import {BlitzKriegSound} from "../../sound/BlitzKriegSound";

export class DDayGameFeatureController extends WinPresentationController {
    private _bombContainer: PIXI.Container;
    private _explosionContainer: PIXI.Container;

    constructor() {
        super("FeatureController", false);
    }

    protected hasWin(): boolean {
        return DDay.model.parsedGameData.featureInfo.length > 0;
    }

    protected async createWinAnimation(): Promise<void> {
        await new Promise<any>(resolve => {
            DDay.model.parsedGameData.featureInfo.forEach((feature: IFeatureData) => {
                DDay.backgroundView.enableTextEffect(feature.Index);
            });
            this.playFeatureAnimation(0, resolve);
        });

    }

    protected playFeatureAnimation(idx: number, resolve: (value: any) => void) {
        let featureTl: TimelineLite = new TimelineLite();
        if (idx === 0) {
            featureTl.add(DDay.backgroundView.enableDisableEffect(true));
        }
        if (idx == DDay.model.parsedGameData.featureInfo.length) {
            featureTl.add([DDay.backgroundView.fadeOutBackground(), () => {
                DDay.reelBackground.resetRadioSignal();
                DDay.backgroundView.enableDisableEffect(false);
            }]);
            featureTl.add(() => {
                resolve(this);
            });
        } else {
            let featureInfo: IFeatureData = DDay.model.parsedGameData.featureInfo[idx];
            if (DDay.model.gameData.mode === BlitzKriegGameMode.NORMAL) {
                DDay.reelBackground.playRadioSignal(featureInfo.Index + 1).play();
            } else {
                DDay.reelBackground.playRadioSignalForFSSFSLoop(featureInfo.Index).play();
            }
            featureTl.add([DDay.backgroundView.fadeOutBackground(0.6 - (idx * 0.1), 0.2), () => {
                if (featureInfo.Index !== 4) {
                    let soundName: string = "";
                    switch (featureInfo.Index) {
                        case 0:
                            soundName = featureInfo.leftToRight ? "featureStukaLefttoright" : "featureStukaRighttoleft";
                            break;
                        case 1:
                            soundName = "featurePanzer";
                            break;
                        case 2:
                            soundName = "featureBomber";
                            break;
                        case 3:
                            soundName = "featureHowitzer";
                            break;
                    }
                    BlitzKriegSound.playTrack({name: soundName});
                }
            }]);
            if (featureInfo.Index === 0) {
                featureTl.add([() => {
                    DDay.reelBackground.addScreenGlow();
                    this.playShadowAnimation();
                }]);
                featureTl.to(this, {duration: 0.5});
                featureTl.add([DDay.featureBackground.playFighterPlaneAnimation(featureInfo), this.splitFighterPlaneReelSymbol(featureInfo, 1.2),
                    this.highlightFighterPlaneSymbols(featureInfo, 0.8), DDay.reelBackground.getXWaysCountByFeature()]);
                featureTl.add([this.disableFeatureAnimations(), () => {
                    this.enableAllSymbols()
                }, TweenLite.to(this, {duration: 0.1})]);
                featureTl.to(this, {duration: 0.1});
            } else if (featureInfo.Index === 1) {
                featureTl.add(() => {
                    DDay.reelBackground.enableTankBackgroundEffect()
                });
                featureTl.add([DDay.featureBackground.playTankAnimation(featureInfo), this.convertTankRowIntoWild(featureInfo, 0.5), DDay.reelBackground.getXWaysCountByFeature(),
                    () => {
                        this.highlightTankSymbols(featureInfo);
                    }]);
                featureTl.add(() => {
                    this.enableAllSymbols()
                });
            } else if (featureInfo.Index === 2) {
                featureTl.add([() => {
                    DDay.reelBackground.addBomberPlaneGlow();
                }]);
                featureTl.add([DDay.featureBackground.playStukaAnimation(featureInfo), this.convertStukaReelIntoWild(featureInfo, 0.6), DDay.reelBackground.getXWaysCountByFeature(),
                    () => {
                        this.highlightBomberSymbols(featureInfo);
                    }]);
                featureTl.add([() => {
                    this.enableAllSymbols()
                }, TweenLite.to(this, {duration: 0.1})]);
                if (this._bombContainer.children.length > 0) {
                    featureTl.to(this, {duration: 0.2});
                }
                featureTl.add(() => {
                    {
                        onComplete: () => {
                            NolimitApplication.getLayerByName(Layers.FOREGROUND)?.removeChild(this._explosionContainer);
                            NolimitApplication.getLayerByName(Layers.FOREGROUND)?.removeChild(this._bombContainer);
                            this._explosionContainer.removeChildren();
                            this._bombContainer.removeChildren();
                        }
                    }
                })
            } else if (featureInfo.Index === 3) {
                featureTl.add([() => {
                }, DDay.reelBackground.getXWaysCountByFeature(), DDay.featureBackground.playArtilleryAnimation(featureInfo), this.convertRandomSymbolsIntoWild(featureInfo, 0.3)]);
                featureTl.add([() => {
                    this.enableAllSymbols()
                }, TweenLite.to(this, {duration: 0.1}), DDay.featureBackground.disableArtillery()]);
            } else if (featureInfo.Index === 4) {
                if (DDay.model.parsedGameData.mode === BlitzKriegGameMode.NORMAL) {
                    featureTl.add(DDay.atomicWildAnimation.play(true));
                }
                featureTl.add(DDay.atomicWildAnimation.playSettledAnim());
                featureTl.add(() => {
                    this.convertRandomSymbolsIntoWild2x(featureInfo);
                    DDay.reelBackground.getXWaysCountByFeature();
                });
                featureTl.add([() => {
                    DDay.atomicWildAnimation.remove();
                    this.enableAllSymbols()
                }, TweenLite.to(this, {duration: 0.1})]);

            }
            featureTl.add(() => {
                this.playFeatureAnimation(idx + 1, resolve);
            });
        }
    }

    protected convertRandomSymbolsIntoWild(featureInfo: IFeatureData, delay: number): TimelineLite {
        let symbolExplosionContainer: PIXI.Container = new PIXI.Container();
        let tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                NolimitApplication.getLayerByName(Layers.FOREGROUND)?.removeChild(symbolExplosionContainer);
                symbolExplosionContainer.removeChildren();
            }
        });
        let explosionSoundPlayed: boolean[] = [false, false, false, false, false];
        let stopperTl: TimelineLite = new TimelineLite();
        let reverseStopperTl: TimelineLite = new TimelineLite();
        NolimitApplication.getLayerByName(Layers.FOREGROUND)?.addChild(symbolExplosionContainer);
        let reelTl: TimelineLite = new TimelineLite();
        for (let reelId: number = 0; reelId <= 4; reelId++) {
            let reelController: BlitzKriegReelController = DDay.reels[reelId];
            let symbolAnimation: TimelineLite[] = [];
            reelController.reelView.allSymbols.forEach((symbol: DDaySymbol, symIdx: number) => {
                let symbolTl: TimelineLite = new TimelineLite();
                if (symIdx > 0 && symIdx <= DDay.reels[reelId].getVisibleSymbols()) {
                    let previousMultiplier: number = symbol.getSymbolMultiplier();
                    if (featureInfo.symbols!.includes(symbol.symbolName)) {
                        let explosion: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("Explosion"));
                        let crossHair = new PIXI.Sprite(DDay.assetLoader.getTextures("Anticipation/crosshair2")[0]);
                        crossHair.anchor.set(0.5, 0.5);
                        crossHair.alpha = 0;
                        crossHair.position = symbol.getGlobalPosition();
                        explosion.position = symbol.getGlobalPosition();
                        symbolExplosionContainer.addChild(explosion, crossHair);
                        if (symbol.isSplit && (symbol.symbolName !== BlitzkriegSymbols.W && symbol.symbolName !== BlitzkriegSymbols.W1)) {
                            previousMultiplier++;
                            symbol.setSymbolMultiplier(previousMultiplier);
                        }
                        if (symbol.symbolName == BlitzkriegSymbols.W || symbol.symbolName == BlitzkriegSymbols.W1) {
                            previousMultiplier++;
                            symbol.setSymbolMultiplier(previousMultiplier);
                        }
                        symbolTl.add([TweenLite.fromTo(crossHair.scale, {
                            x: 1,
                            y: 1
                        }, {
                            x: 1.5,
                            y: 1.5,
                            duration: 0.1,
                            yoyo: true,
                            repeat: 4
                        }), TweenLite.to(crossHair, {
                            alpha: 1,
                            duration: 0.05
                        })]).then(() => {
                            crossHair.alpha = 0;
                        });
                        symbolTl.add([() => {
                            DDay.createTimelineForAnimation(explosion, 0, "explosion", false, 1).play();
                            if (!explosionSoundPlayed[reelId]) {
                                explosionSoundPlayed[reelId] = true;
                                BlitzKriegSound.playBomberExplodeWithDavidPanning(BlitzKriegSound.BOMBER_WILD_EXPLODE.next(), reelId);
                            }
                        }, TweenLite.to(this, {duration: 0.2})], "<+=0.02");
                        symbolTl.add(() => {
                            symbol.changeSymbol(BlitzkriegSymbols.W)
                        }, ">-=0.2");

                        if (symbol.getSymbolMultiplier() > 1) {
                            symbolTl.add([symbol.playWildMultiplierAnimation(), () => {
                                BlitzKriegSound.playTrack({name: BlitzKriegSound.WILD_MULTIPLIED});
                            }]);
                        }
                        symbol.resetMultiplierPosition();
                    }

                    if (symbol.symbolName === BlitzkriegSymbols.L4) {
                        stopperTl.add(symbol.getStateAnimation(BlitzKriegSymbolState.STOPPER, {
                            duration: 0,
                            alpha: 1
                        }, {duration: 0}, [0, 25]), 0);
                        reverseStopperTl.add(symbol.getStateAnimation(BlitzKriegSymbolState.STOPPER, {
                            duration: 0,
                            alpha: 1
                        }, {duration: 0}, [25]), 0);
                    }
                }
                symbolAnimation.push(symbolTl);
            });
            reelTl.add(symbolAnimation);
        }
        tl.add([stopperTl, () => {
            BlitzKriegSound.playTrack({name: "featureHowitzerL4Hide"});
        }]);
        tl.to(this, {duration: delay});
        tl.add(reelTl);
        tl.add([reverseStopperTl, () => {
            DDay.featureBackground.playArtilleryHideAnimation().play();
            BlitzKriegSound.playTrack({name: "featureHowitzerL4Unhide"});
        }]);
        tl.add(() => {
            DDay.reelBackground.enableTankBackgroundEffect();
        }, "<+=0.2")
        return tl;
    }

    protected convertRandomSymbolsIntoWild2x(featureInfo: IFeatureData): void {
        if (featureInfo.coordinates) {
            let row: number = featureInfo.coordinates[0];
            let col: number = featureInfo.coordinates[1];
            let reelController: BlitzKriegReelController = DDay.reels[row];
            let targetSymbol: DDaySymbol = reelController.getSymbol(col);
            let previousMultiplier = targetSymbol.getSymbolMultiplier();
            targetSymbol.resetMultiplierPosition();
            reelController.reelView.addRemoveWinSymbol(targetSymbol, true);
            if (featureInfo.multiplier) {
                targetSymbol.updateWildIndex(DDay.commonService.getAtomicWildIndex(featureInfo!.multiplier));
            }
            targetSymbol.changeSymbol(BlitzkriegSymbols.W);
            if (featureInfo.multiplier) {
                previousMultiplier = featureInfo.multiplier;
                targetSymbol.setSymbolMultiplier(previousMultiplier);
                targetSymbol.showWildMultiplier();
                BlitzKriegSound.playTrack({name: BlitzKriegSound.WILD_MULTIPLIED});
                targetSymbol.resetMultiplierPosition();
            }
        }
    }

    protected convertStukaReelIntoWild(featureInfo: IFeatureData, delay: number): TimelineLite {
        this._explosionContainer = new PIXI.Container();
        this._bombContainer = new PIXI.Container();
        let tl: TimelineLite = new TimelineLite();
        let stopperTl: TimelineLite = new TimelineLite();
        let blastAnimation: TimelineLite = new TimelineLite();
        NolimitApplication.getLayerByName(Layers.FOREGROUND)?.addChild(this._explosionContainer);
        NolimitApplication.getLayerByName(Layers.FOREGROUND)?.addChild(this._bombContainer);
        let featureTl: TimelineLite[] = [];
        let isStopperSymbolAvailable: boolean = this.isStopperSymbolAvailable(BlitzkriegSymbols.L2, featureInfo.reels);
        let bomberBlastTime: number[] = [];
        let continousBombsOnOneReel: number = 0;
        let symbolOffset: number[] = [2, 1, 0, 1, 2];
        let bombSoundPlayed: boolean[] = [false, false, false, false, false];
        featureInfo.reels?.forEach((reel: number) => {
            let reelTl: TimelineLite = new TimelineLite();
            let reelOffsetSymbols: number[] = [0.8, 0.6, 0.32, 0.6, 0.8];
            let reelController: BlitzKriegReelController = DDay.reels[reel];
            let delayOffset: number = (reelOffsetSymbols[reel] + delay);
            if (isStopperSymbolAvailable) {
                delayOffset = delayOffset - 0.5;
            }
            reelTl.to(this, {
                duration: delayOffset
            });
            let bombsOnReel = 0;
            for (let index: number = 0; index < (reelController.reelView.allSymbols.length - 2); index++) {
                let symbolOffset: number[] = [0, 1, 2, 1, 0];

                let symbol: DDaySymbol = reelController.getSymbol(index);
                let previousMultiplier: number = symbol.getSymbolMultiplier();
                if (symbol.symbolName === BlitzkriegSymbols.L2) {
                    DDay.reels[reel].reelView.addScatterSymbol(symbol, true);
                    stopperTl.add([() => {
                        symbol.getStateAnimation(BlitzKriegSymbolState.STOPPER, {
                            duration: 0,
                            alpha: 1
                        }, {duration: 0}, [0, 15])
                    }, TweenLite.to(this, {duration: 0.5})], 0);
                    let durr: number = (this.bombersSpeedOffset(reel, index) + delayOffset);
                    if (!bomberBlastTime.includes(durr)) {
                        bomberBlastTime.push(durr);
                        blastAnimation.add(() => {
                            BlitzKriegSound.playTrack({name: BlitzKriegSound.FEATURE_BOMBER_L2_FIRE});
                            BlitzKriegSound.playTrack({name: BlitzKriegSound.FEATURE_BOMBER_EXPLODE});
                        }, durr);
                    }
                    blastAnimation.add(() => {
                        DDay.featureBackground.blastBomber(reel);
                        symbol.getStateAnimation(BlitzKriegSymbolState.STOPPER, {
                            duration: 0,
                            alpha: 1
                        }, {duration: 0}, [15]);
                    }, durr);
                    break;
                }
                if (symbol.symbolName != BlitzkriegSymbols.S) {
                    if (symbol.isSplit) {
                        previousMultiplier++;
                        symbol.setSymbolMultiplier(previousMultiplier);
                    }
                    if (symbol.symbolName == BlitzkriegSymbols.W || symbol.symbolName == BlitzkriegSymbols.W1) {
                        previousMultiplier++;
                        symbol.setSymbolMultiplier(previousMultiplier);
                    }
                    bombsOnReel++;
                    if (continousBombsOnOneReel < bombsOnReel) {
                        continousBombsOnOneReel = bombsOnReel;
                    }
                    reelTl.add(() => {
                        let bombTl: TimelineLite = new TimelineLite();
                        let bomb: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("bomb"));
                        bomb.alpha = 0;
                        this._bombContainer.addChild(bomb);
                        bomb.position = symbol.getGlobalPosition();
                        bombTl.add([DDay.createTimelineForAnimation(bomb, 0, "drop_bomb", false, 1, 0).timeScale(1.5), () => {
                            bomb.alpha = 1;
                        }]);
                        bombTl.add([() => {
                            bomb.alpha = 0;
                            let explosion: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("Explosion"));
                            explosion.position = symbol.getGlobalPosition();
                            this._explosionContainer.addChild(explosion);
                            DDay.createTimelineForAnimation(explosion, 0, "explosion", false, 1);
                            symbol.changeSymbol(BlitzkriegSymbols.W);
                        }]);
                        symbol.resetMultiplierPosition();
                        bombTl.add(() => {
                            if (!bombSoundPlayed[index + symbolOffset[reel]]) {
                                bombSoundPlayed[index + symbolOffset[reel]] = true;
                                BlitzKriegSound.playBomberExplodeWithDavidPanning(BlitzKriegSound.BOMBER_WILD_EXPLODE.next(), index);
                            }
                            if (symbol.getSymbolMultiplier() > 1) {
                                symbol.playWildMultiplierAnimation();
                                BlitzKriegSound.playTrack({name: BlitzKriegSound.WILD_MULTIPLIED});
                            }
                        });
                        bombTl.play();
                    });
                    reelTl.to(this, {duration: (index >= symbolOffset[reel]) ? 0.15 : 0.25});
                } else {
                    reelTl.to(this, {
                        duration: (index > symbolOffset[reel]) ? 0.15 : 0.25
                    });
                }
            }
            featureTl.push(reelTl);
        });
        featureTl.push(blastAnimation);
        tl.add([stopperTl, () => {
            if (isStopperSymbolAvailable) {
                BlitzKriegSound.playTrack({name: BlitzKriegSound.FEATURE_BOMBER_L2_READY});
            }
        }]);
        tl.add(featureTl);
        tl.add(TweenLite.to(this, {duration: continousBombsOnOneReel * 0.2}));
        return tl;
    }

    protected splitFighterPlaneReelSymbol(featureInfo: IFeatureData, delay: number): TimelineLite {
        DDay.bulletOverlays = [[], [], [], [], []];
        let mainTl: TimelineLite = new TimelineLite();
        mainTl.to(this, {duration: delay});
        let featureTl: TimelineLite[] = [];
        let layer: StageLayer | undefined = NolimitApplication.getLayerByName(Layers.FOREGROUND_ANIMATION);
        let symbolSoundIdx: boolean[] = [false, false, false, false, false];
        let symbolSoundPosition: number = 0;
        featureInfo.diagonals?.forEach((row: number): void => {
            // Diagonal are changed, now it's from top to bottom.
            row = (6 - row);
            let reelTl: TimelineLite = new TimelineLite();
            let symbols: [number, number][] = this.getSymbolsOfFighterPlaneRow(row, featureInfo.leftToRight);
            let offset: number = 1 / symbols.length;
            symbols.forEach((symbolPosition: [number, number], index: number) => {
                let reelController: BlitzKriegReelController = DDay.reels[symbolPosition[0]];
                let symbol: DDaySymbol = reelController.getSymbol(symbolPosition[1]);
                let tl: any[] = [];
                if (symbol.symbolName != BlitzkriegSymbols.S && symbol.symbolName != BlitzkriegSymbols.W && symbol.symbolName != BlitzkriegSymbols.W1) {
                    symbol.isSplit = true;
                    symbol.leftToRight = featureInfo.leftToRight ? featureInfo.leftToRight : false;
                    tl.push(() => {
                        let bulletAnim: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("bulletHole"));
                        bulletAnim.position = symbol.getGlobalPosition();
                        layer?.addChildAt(bulletAnim, 0);
                        DDay.bulletOverlays[symbolPosition[0]][symbolPosition[1]] = bulletAnim;
                        bulletAnim.state.setAnimation(0, "split_" + (featureInfo.leftToRight ? "1" : "2"), false);
                        symbol.getStateAnimation(featureInfo.leftToRight ? BlitzKriegSymbolState.SPLIT1_TRANSFORM : BlitzKriegSymbolState.SPLIT2_TRANSFORM, {
                            duration: 0,
                            alpha: 1
                        }, {duration: 0}).add(() => {
                            symbol.getStateAnimation(BlitzKriegSymbolState.NORMAL, {
                                duration: 0,
                                alpha: 1
                            }, {duration: 0});
                        });
                    });
                    if (!symbolSoundIdx[index]) {
                        symbolSoundIdx[index] = true;
                        symbolSoundPosition++;
                        tl.push(() => {
                            BlitzKriegSound.playTrack({name: "featureStukaSplit0" + symbolSoundPosition});
                        });
                    }
                } else if ((symbol.symbolName == BlitzkriegSymbols.W || symbol.symbolName == BlitzkriegSymbols.W1)) {
                    let previousMultiplier = symbol.getSymbolMultiplier();
                    previousMultiplier = previousMultiplier * 2;
                    symbol.resetMultiplierPosition();
                    symbol.setSymbolMultiplier(previousMultiplier);
                    tl.push(() => {
                        symbol.playWildMultiplierAnimation().play();
                        BlitzKriegSound.playTrack({name: BlitzKriegSound.WILD_MULTIPLIED});
                    });
                }
                reelTl.add(tl);
                reelTl.to(this, {
                    duration: offset
                });
            });

            featureTl.push(reelTl);
        });
        mainTl.add(featureTl);
        return mainTl;
    }

    protected convertTankRowIntoWild(featureInfo: IFeatureData, delay: number): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        let featureTl: TimelineLite[] = [];
        let stopperTl: TimelineLite[] = [];
        let reverseStopperTl: TimelineLite[] = [];
        let isStopperSymbolAvailable: boolean = false;
        let explosionSoundPlayed: boolean[] = [false, false, false, false, false];
        featureInfo.rows?.forEach((row: number): void => {
            let reelTl: TimelineLite = new TimelineLite();
            let stopperAnim: TimelineLite = new TimelineLite();
            let reverseStopperAnim: TimelineLite = new TimelineLite();
            let offset: number = 0.8 / 5;
            let length: number = 0;
            DDay.reels.forEach((reelController: BlitzKriegReelController, reelId: number): void => {
                let symbolCount: number = reelController.getVisibleSymbols();
                let overflowSymbols: number = 5 - symbolCount;
                if ((symbolCount + row + 1) > 5) {
                    length++;
                    let symbol: DDaySymbol = reelController.getSymbol((row) - overflowSymbols);
                    if (symbol.symbolName.includes("L") && symbol.symbolName !== BlitzkriegSymbols.L3) {
                        let previousMultiplier = symbol.getSymbolMultiplier();
                        if (symbol.isSplit) {
                            previousMultiplier++;
                            symbol.setSymbolMultiplier(previousMultiplier);
                        }
                        reelTl.add([this.playTransformWildAnimation(symbol), () => {
                            if (!explosionSoundPlayed[reelId]) {
                                explosionSoundPlayed[reelId] = true;
                                BlitzKriegSound.playBomberExplodeWithDavidPanning(BlitzKriegSound.BOMBER_WILD_EXPLODE.next(), reelId);
                            }
                        }], offset);
                    } else {
                        if (symbol.symbolName === BlitzkriegSymbols.L3) {
                            isStopperSymbolAvailable = true;
                            stopperAnim.add(() => {
                                symbol.getStateAnimation(BlitzKriegSymbolState.STOPPER, {
                                    duration: 0,
                                    alpha: 1
                                }, {duration: 0}, [0, 25])
                            }, 0);
                            reverseStopperAnim.add(() => {
                                symbol.getStateAnimation(BlitzKriegSymbolState.STOPPER, {
                                    duration: 0,
                                    alpha: 1
                                }, {duration: 0}, [25])
                            }, 0);
                        }
                        if ((symbol.symbolName == BlitzkriegSymbols.W || symbol.symbolName == BlitzkriegSymbols.W1)) {
                            let previousMultiplier = symbol.getSymbolMultiplier();
                            previousMultiplier++;
                            symbol.setSymbolMultiplier(previousMultiplier);
                        }
                    }
                    if (symbol.getSymbolMultiplier() > 1) {
                        reelTl.add(() => {
                            symbol.resetMultiplierPosition();
                            symbol.playWildMultiplierAnimation();
                            BlitzKriegSound.playTrack({name: BlitzKriegSound.WILD_MULTIPLIED});
                        }, offset);
                    }
                    offset = offset + (0.8 / 5);
                }
            });
            if (stopperAnim.totalDuration() == 0) {
                stopperAnim.to(this, {
                    duration: 0.8676
                });
            }
            if (reverseStopperAnim.totalDuration() == 0) {
                reverseStopperAnim.to(this, {
                    duration: 0.8676
                });
            }
            stopperTl.push(stopperAnim);
            reverseStopperTl.push(reverseStopperAnim);
            featureTl.push(reelTl);
        });
        if (isStopperSymbolAvailable) {
            let soundTl: TimelineLite = new TimelineLite();
            let reverseSoundTl: TimelineLite = new TimelineLite();
            soundTl.add(() => {
                BlitzKriegSound.playTrack({name: "featurePanzerL3Hide"});
            });
            reverseSoundTl.add(() => {
                BlitzKriegSound.playTrack({name: "featurePanzerL3Unhide"});
            });
            stopperTl.push(soundTl);
            reverseStopperTl.push(reverseSoundTl);
        }
        tl.add(stopperTl);
        if (stopperTl.length > 0) {
            tl.to(this, {duration: delay - 0.5});
        } else {
            tl.to(this, {duration: delay});
        }
        tl.add(featureTl, ">-=0.10");
        tl.add(reverseStopperTl);
        return tl;
    }

    protected highlightTankSymbols(featureInfo: IFeatureData): void {
        const tankSymbolPos: boolean[][] = ArrayHelper.initArrayWithValues<boolean[]>(DDayGameConfig.REELS_NUM, (index: number) => {
            return ArrayHelper.initArrayWithValues<boolean>(DDay.model.parsedGameData.evaluatedArea[index].length, () => false);
        });
        featureInfo.rows?.forEach((row: number): void => {
            DDay.reels.forEach((reelController: BlitzKriegReelController, reelId: number): void => {
                let symbolCount: number = reelController.getVisibleSymbols();
                let overflowSymbols: number = 5 - symbolCount;
                if ((symbolCount + row + 1) > 5) {
                    tankSymbolPos[reelId][row - overflowSymbols] = true;
                }
            });
        });
        tankSymbolPos.forEach((tankSymbols: boolean[], reelId: number) => {
            tankSymbols.forEach((isActiveRow: boolean, symbolId: number) => {
                if (!isActiveRow) {
                    DDay.reels[reelId].getSymbol(symbolId).getStateAnimation(BlitzKriegSymbolState.NO_WIN, {
                        duration: 0,
                        alpha: 1
                    }, {duration: 0});
                } else {
                    DDay.reels[reelId].getSymbol(symbolId).getStateAnimation(BlitzKriegSymbolState.NORMAL, {
                        duration: 0,
                        alpha: 1
                    }, {duration: 0});
                }
            });
        });
    }

    protected highlightBomberSymbols(featureInfo: IFeatureData): void {
        const tankSymbolPos: boolean[][] = ArrayHelper.initArrayWithValues<boolean[]>(DDayGameConfig.REELS_NUM, (index: number) => {
            return ArrayHelper.initArrayWithValues<boolean>(DDay.model.parsedGameData.evaluatedArea[index].length, () => false);
        });
        DDay.reels.forEach((reel: BlitzKriegReelController, reelId: number) => {
            let isFeatureReel: boolean | undefined = featureInfo.reels?.includes(reelId);
            DDay.reels[reelId].reelView.allSymbols.forEach((symbol: DDaySymbol, symId: number): void => {
                if (!isFeatureReel) {
                    symbol.getStateAnimation(BlitzKriegSymbolState.NO_WIN, {duration: 0, alpha: 1}, {duration: 0});
                } else {
                    symbol.getStateAnimation(BlitzKriegSymbolState.NORMAL, {duration: 0, alpha: 1}, {duration: 0});
                }
            });
        });
    }

    protected playTransformWildAnimation(symbol: DDaySymbol): TimelineLite {
        let transformWild: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset("transform"));
        transformWild.position = symbol.getGlobalPosition();
        let tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                NolimitApplication.getLayerByName(Layers.FOREGROUND_ANIMATION)?.removeChild(transformWild);
            }
        });
        tl.add(() => {
            NolimitApplication.getLayerByName(Layers.FOREGROUND_ANIMATION)?.addChild(transformWild);
        })
        tl.add(DDay.createTimelineForAnimation(transformWild, 0, "transform", false, 1, 0.2));
        tl.add([() => {
            symbol.changeSymbol(BlitzkriegSymbols.W).play();
        }, TweenLite.to(this, {duration: 0.2})]);
        return tl;
    }


    public highlightFighterPlaneSymbols(featureInfo: IFeatureData, delay: number = 0): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        tl.to(this, {duration: delay});
        let layer: StageLayer | undefined = NolimitApplication.getLayerByName(Layers.FEATURE_ANIMATIONS);
        [0, 1, 2, 3, 4, 5, 6].forEach((row: number): void => {
            // Diagonal are changed, now it's from top to bottom.
            row = (6 - row);
            let symbols: [number, number][] = this.getSymbolsOfFighterPlaneRow(row, featureInfo.leftToRight);
            let rowTl: TimelineLite = new TimelineLite();
            let isTriggerred: boolean | undefined = featureInfo.diagonals?.includes((6 - row), 0);
            symbols.forEach((symbolPosition: [number, number], idx: number) => {
                let symbol: DDaySymbol = DDay.reels[symbolPosition[0]].getSymbol(symbolPosition[1]);
                if (isTriggerred) {
                    if (symbol.symbolName !== BlitzkriegSymbols.S) {
                        let glow: PIXI.Sprite = new PIXI.Sprite(DDay.assetLoader.getTextures("glow")[0]);
                        glow.position = symbol.getGlobalPosition();
                        glow.anchor.set(0.5, 0.5);
                        glow.alpha = 0;
                        layer?.addChild(glow);
                        rowTl.to(glow, {
                            alpha: 1,
                            duration: 0.1
                        });
                    }
                } else {
                    rowTl.add(symbol.getStateAnimation(BlitzKriegSymbolState.NO_WIN, {
                        duration: 0,
                        alpha: 1
                    }, {duration: 0}));
                }
            });
            tl.add(rowTl, "start");
        });
        tl.addLabel("start");
        return tl;
    }

    private bombersSpeedOffset(reelId: number, symIdx: number): number {
        let symbolOffset: number[] = [0, 1, 2, 1, 0];
        let delay = 0.15;
        let delayTotal: number = symbolOffset[reelId] * delay;
        if (symIdx > symbolOffset[reelId]) {
            delayTotal = delayTotal + ((symIdx - symbolOffset[reelId]) * (delay / 2));
        } else {
            delayTotal = delayTotal - ((symbolOffset[reelId] - symIdx) * (delay));
        }
        return delayTotal;
    }

    private isStopperSymbolAvailable(symbolName: string, activeReels: number[] | undefined): boolean {
        let isStopperSymbolAvailable: boolean = false;
        DDay.reels.forEach((reel: BlitzKriegReelController, reelId: number) => {
            if (activeReels && activeReels.includes(reelId)) {
                for (let idx: number = 0; idx < reel.reelView.allSymbols.length - 2; idx++) {
                    if (reel.getSymbol(idx).symbolName === symbolName) {
                        isStopperSymbolAvailable = true;
                    }
                }
            }
        });
        return isStopperSymbolAvailable;
    }

    private playShadowAnimation(): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        let shadow1: PIXI.Sprite = new PIXI.Sprite(DDay.assetLoader.getTextures("featureSymbols/fighterPlaneShadow")[0]);
        shadow1.position.set(0, 0);
        shadow1.anchor.set(0.5, 0.5);
        shadow1.scale.set(1.5, 1.5);
        shadow1.rotation = DDayGameConfig.degToRad(135);
        let shadow2: PIXI.Sprite = new PIXI.Sprite(DDay.assetLoader.getTextures("featureSymbols/fighterPlaneShadow")[0]);
        shadow2.position.set(-100, 100);
        shadow2.anchor.set(0.5, 0.5);
        shadow2.scale.set(1.5, 1.5);
        shadow2.rotation = DDayGameConfig.degToRad(135);
        let shadow3: PIXI.Sprite = new PIXI.Sprite(DDay.assetLoader.getTextures("featureSymbols/fighterPlaneShadow")[0]);
        shadow3.position.set(-200, 200);
        shadow3.anchor.set(0.5, 0.5);
        shadow3.scale.set(1.5, 1.5);
        shadow3.rotation = DDayGameConfig.degToRad(135);
        let shadow4: PIXI.Sprite = new PIXI.Sprite(DDay.assetLoader.getTextures("featureSymbols/fighterPlaneShadow")[0]);
        shadow4.position.set(720, 0);
        shadow4.anchor.set(0.5, 0.5);
        shadow4.scale.set(1.5, 1.5);
        shadow4.rotation = DDayGameConfig.degToRad(215);
        let shadow5: PIXI.Sprite = new PIXI.Sprite(DDay.assetLoader.getTextures("featureSymbols/fighterPlaneShadow")[0]);
        shadow5.position.set(820, 100);
        shadow5.anchor.set(0.5, 0.5);
        shadow5.scale.set(1.5, 1.5);
        shadow5.rotation = DDayGameConfig.degToRad(215);
        let shadow6: PIXI.Sprite = new PIXI.Sprite(DDay.assetLoader.getTextures("featureSymbols/fighterPlaneShadow")[0]);
        shadow6.position.set(920, 200);
        shadow6.anchor.set(0.5, 0.5);
        shadow6.scale.set(1.5, 1.5);
        shadow6.rotation = DDayGameConfig.degToRad(215);
        NolimitApplication.getLayerByName(Layers.FOREGROUND_ANIMATION)?.addChild(shadow1, shadow2, shadow3, shadow4, shadow5, shadow6);
        tl.fromTo(shadow1, {
            x: 0,
            y: 0
        }, {
            x: 120,
            y: 100,
            alpha: 0,
            duration: 1.5,
            ease: Power2.easeOut
        }, 0);
        tl.fromTo(shadow2, {
            x: -100,
            y: 100
        }, {
            x: 20,
            y: 200,
            alpha: 0,
            duration: 1.5,
            ease: Power2.easeOut
        }, 0);
        tl.fromTo(shadow3, {
            x: -200,
            y: 200
        }, {
            x: -80,
            y: 300,
            alpha: 0,
            duration: 1.5,
            ease: Power2.easeOut
        }, 0);
        tl.fromTo(shadow4, {
            x: 720,
            y: 0
        }, {
            x: 600,
            y: 100,
            alpha: 0,
            duration: 1.5,
            ease: Power2.easeOut
        }, 0);
        tl.fromTo(shadow5, {
            x: 820,
            y: 100
        }, {
            x: 700,
            y: 200,
            alpha: 0,
            duration: 1.5,
            ease: Power2.easeOut
        }, 0);
        tl.fromTo(shadow6, {
            x: 920,
            y: 200
        }, {
            x: 800,
            y: 300,
            alpha: 0,
            duration: 1.5,
            ease: Power2.easeOut
        }, 0);
        return tl;
    }

    protected getSymbolsOfFighterPlaneRow(row: number, isLeft: boolean = true): [number, number][] {
        let symbolsCountOnReel: number[] = DDayGameConfig.REELS_SYM_COUNT;
        let position: [number, number][] = [];
        let reelId: number = row < 5 ? 0 : row - 4;
        if (!isLeft) {
            reelId = row < 5 ? 4 : (4 - (row - 4));
        }
        let symbolId: number = row < 5 ? (5 - (row + 1)) : 0;
        while (symbolId < 5) {
            let reelOverflowSymbols: number = (5 - symbolsCountOnReel[reelId]);
            if (symbolId >= reelOverflowSymbols) {
                position.push([reelId, (symbolId - reelOverflowSymbols)]);
            }
            isLeft ? reelId++ : reelId--;
            symbolId++;
        }
        return position;
    }

    private async enableAllSymbols() {
        let tl: TimelineLite = new TimelineLite();
        DDay.reels.forEach((reel: BlitzKriegReelController) => {
            reel.reelView.allSymbols.forEach((symbol: DDaySymbol) => {
                tl.add(symbol.getStateAnimation(BlitzKriegSymbolState.NORMAL, {
                    duration: 0,
                    alpha: 1
                }, {duration: 0}), 0);
            });
        });
        await tl;
    }

    private disableFeatureAnimations(): TimelineLite {
        let layer: StageLayer | undefined = NolimitApplication.getLayerByName(Layers.FEATURE_ANIMATIONS);
        let tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                layer?.removeChildren();
            }
        });
        layer?.children.forEach((child => {
            tl.to(child, {alpha: 0.1, duration: 0.1}, 0);
        }));
        return tl;
    }
}
